export const E2E_USER_AGENT = 'e2e-test-user-agent';
